import './Moderator.css'

const Moderator = () => {
  return (
    <>
      <div className="spinner-1"></div>
      <div className="spinner-2"></div>
      <div className="spinner-3"></div>
      <div className="spinner-4"></div>
      <div className="spinner-5"></div>
      <div className="spinner-6"></div>
      <div className="spinner-7"></div>
      <div className="spinner-8"></div>
      <div className="spinner-9"></div>
      <div className="spinner-10"></div>
    </>
  );
};

export default Moderator;